/**
 * SNS campus dropdown — college vs school, with linked departments.
 */

export const SNS_CAMPUSES = [
  {
    id: "sns-cot",
    name: "SNS College of Technology",
    kind: "college",
    stream: "tech",
    departments: [
      "CSE",
      "IT",
      "AI & DS",
      "ECE",
      "EEE",
      "Mechanical",
      "Mechatronics",
      "Civil",
      "AIDS",
      "Other",
    ],
  },
  {
    id: "sns-coe",
    name: "SNS College of Engineering",
    kind: "college",
    stream: "tech",
    departments: [
      "CSE",
      "IT",
      "ECE",
      "EEE",
      "Mechanical",
      "Civil",
      "Automobile",
      "Other",
    ],
  },
  {
    id: "sns-arts",
    name: "Dr. SNS Rajalakshmi College of Arts & Science",
    kind: "college",
    stream: "arts",
    departments: [
      "Computer Science",
      "BCA",
      "BBA",
      "B.Com",
      "English",
      "Mathematics",
      "Physics",
      "Chemistry",
      "Visual Communication",
      "Psychology",
      "Other",
    ],
  },
  {
    id: "sns-academy",
    name: "SNS Academy",
    kind: "school",
    stream: "school",
    departments: [
      "General",
      "Science stream",
      "Commerce stream",
      "Computer Science",
      "Other",
    ],
    /** School grades 1–12 (not college year/sem) */
    grades: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
  },
];

export function getCampusByName(name) {
  const n = String(name || "").trim().toLowerCase();
  if (!n) return null;
  return (
    SNS_CAMPUSES.find((c) => c.name.toLowerCase() === n) ||
    SNS_CAMPUSES.find((c) => n.includes(c.name.toLowerCase()) || c.name.toLowerCase().includes(n)) ||
    null
  );
}

export function isSchoolCampus(name) {
  const c = getCampusByName(name);
  return Boolean(c && c.kind === "school");
}

export function departmentsForCollege(name) {
  const c = getCampusByName(name);
  return c?.departments || ["Other"];
}

export const SEMS_FOR_YEAR = { 1: [1, 2], 2: [3, 4], 3: [5, 6], 4: [7, 8] };
export const YEAR_FROM_SEM = { 1: 1, 2: 1, 3: 2, 4: 2, 5: 3, 6: 3, 7: 4, 8: 4 };
